export default class ExamRevisionForm {
    public body: string
}